const adaptFullPageTakeoverForm = (data: CarouselBanner): BannerStep[] => {
	return [
		{
			step: 1,
			isStepDisabled: false,
			title: "Banner Name",
			note: null,
			type: "multiField",
			fields: [
				{
					type: "text",
					label: "Banner name",
					field: "bannerName",
					order: 1,
					placeholder: "Banner name",
					maxChar: null,
					radioAnswers: null,
					givenAnswer: data.name
				}
			],
			radioAnswers: null
		},
		{
			step: 2,
			isStepDisabled: false,
			title: "Mobile image",
			note: "jpg or png, 856 x 1852px, max 3 Mb",
			type: "multiField",
			fields: [
				{
					type: "file",
					label: "",
					field: "imagePortrait",
					order: 1,
					placeholder: "Upload image for mobile",
					maxChar: null,
					radioAnswers: null,
					givenAnswer: data.image_portrait_uuid ? data.image_portrait_uuid : "",
					preview: "",
					file: data.image_portrait_uuid ? data.image_portrait_uuid : undefined,
					fileHelperText:
						"Image (jpg or png) size 856px width x 1852px height and up to 3 Mb",
					imageProfile: "retail-app-full-page-takeover-mobile"
				}
			],
			radioAnswers: null
		},
		{
			step: 3,
			isStepDisabled: false,
			title: "Tablet image",
			note: "jpg or png, 1366 x 1024px, max 3 Mb",
			type: "multiField",
			fields: [
				{
					type: "file",
					label: "",
					field: "imageLandscape",
					order: 1,
					placeholder: "Upload image for tablet",
					maxChar: null,
					radioAnswers: null,
					givenAnswer: data.image_landscape_uuid
						? data.image_landscape_uuid
						: "",
					preview: "",
					file: data.image_landscape_uuid
						? data.image_landscape_uuid
						: undefined,
					fileHelperText:
						"Image (jpg or png) size 1366px width x 1024px height and up to 3 Mb",
					imageProfile: "retail-app-full-page-takeover-tablet"
				}
			],
			radioAnswers: null
		},
		{
			step: 4,
			isStepDisabled: !data.button_visible ? true : false,
			title: "Button",
			note: null,
			type: "multiField",
			fields: [
				{
					type: "radio",
					label: "Button style",
					field: "buttonVariant",
					order: 1,
					givenAnswer: data.button_style,
					radioAnswers: [
						{
							name: "white",
							order: 1
						},
						{
							name: "black",
							order: 2
						}
					],
					maxChar: null
				},
				{
					type: "text",
					label: "Button text",
					field: "buttonText",
					order: 2,
					placeholder: "Maximum button count is 35 characters.",
					maxChar: 35,
					givenAnswer: data.button_text,
					radioAnswers: null
				},
				{
					type: "text",
					label: "Button URL",
					field: "buttonLink",
					order: 3,
					placeholder: "Button link",
					maxChar: null,
					givenAnswer: data.button_link,
					radioAnswers: null
				}
			],
			radioAnswers: null
		}
	];
};

export default adaptFullPageTakeoverForm;
